import { gql } from '@apollo/client';

export const getCheckoutHealthOfferData = gql`query checkoutHealthOfferData($offerId: String!) {
  checkoutHealthOfferData(id: $offerId) {
      karenca
      hasPolicy
      newPolicyStartDate
      newPolicyStartDateNote
      productCode
      collectContractorPhone
      insuredPerson {
        firstName {
          value
          isEditable
        }
        lastName {
          value
          isEditable
        }
        birthDate {
          value
          isEditable
        }
        gender {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        personalIdNumber {
          value
          isEditable
        }
        personalIdIssuer {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
      }
      contractor {
        personType
        isSamePerson
        person {
          firstName {
            value
            isEditable
          }
          lastName {
            value
            isEditable
          }
          birthDate {
            value
            isEditable
          }
          gender {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }          phoneNumber {
            value
            isEditable
          }
        }
        company {
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          companyName {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }
          phoneNumber {
            value
            isEditable
          }
        }
      }
      delivery {
        asEntity {
          value
          isEditable
        }
        name {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
      }
  }
}
`;
